import { format } from 'date-fns';

/**
 * Day pickers for the loyalty forms. A picked day used to be sent as UTC midnight (new Date('yyyy-MM-dd')), so an
 * "active to" day ended at 02:00/03:00 Athens time on that day, and an ISO value was shown by its UTC date (the
 * previous day for a local midnight). Days are the admin's local days: a start begins the day, an end closes it.
 */

/** The yyyy-MM-dd an `<input type="date">` shows for a stored ISO value. */
export function toDayInput(iso: string | null | undefined): string {
	if (!iso) return '';
	const date = new Date(iso);
	return Number.isNaN(date.getTime()) ? '' : format(date, 'yyyy-MM-dd');
}

/** The start of a picked day, or `notBefore` when that is later (a range picked for today starts now). */
export function dayStartIso(day: string, notBefore?: Date): string | null {
	if (!day) return null;
	const start = new Date(`${day}T00:00:00`);
	return (notBefore && notBefore > start ? notBefore : start).toISOString();
}

/** The last second of a picked day. */
export function dayEndIso(day: string): string | null {
	return day ? new Date(`${day}T23:59:59`).toISOString() : null;
}
